import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css'
})
export class UnauthorizedComponent {
  constructor(private router: Router) { }

  goToLogin() {
    this.router.navigate(['login']);
  }

  goBack(): void {
    // console.log(window, 'and', window.history)
    window.history.back();
    // window.history.replaceState({}, '', '/');

    // Get the total number of history entries
    // const historyLength = window.history.length;
    // console.log(historyLength, 'length');
    
    // if(historyLength && historyLength > 2) {
    //   window.history.go(historyLength - 1);
    // } else {
    //   window.history.back();
    // }
  }
}
